import { v4 as uuidv4 } from 'uuid'
import { CreateTreeNode, TreeNode } from './dtos'

export const createNewNode = (args: CreateTreeNode): TreeNode => {
    return {
        data: {
            id: uuidv4(),
            visibility: 'visible',
            title: 'New node',
            ...args.data
        }
    }
}
